import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo_salone_vincente.png";
import { YouTubePlayer } from "@/components/YouTubePlayer";

const VideoStep5 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  console.log("[VideoStep5] URL params:", {
    groupId: searchParams.get("groupId"),
    Id: searchParams.get("Id"),
    fullQueryString: searchParams.toString(),
  });

  const handleConsultationRequest = async () => {
    setIsLoading(true);

    const groupId = searchParams.get("groupId");
    const id = searchParams.get("Id");

    const webhookUrl = "https://n8n.srv1035791.hstgr.cloud/webhook/72fcb9f2-703f-49d8-b981-fd0722309d90";

    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event: "consultation_button_clicked",
          timestamp: new Date().toISOString(),
          page: "/7",
          source: "VideoStep5",
          groupId: groupId,
          Id: id,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
    } catch (error) {
      console.error("Error sending webhook:", error);
    } finally {
      navigate("/thank-you");
    }
  };

  return (
    <div className="h-screen gradient-subtle flex flex-col p-4">
      {/* Contenuto principale centrato */}
      <div className="flex-1 flex items-center justify-center">
        <div className="max-w-5xl w-full flex flex-col">
          {/* Header orizzontale con logo e titolo */}
          <div className="flex items-center gap-4 mb-2 md:mb-3 animate-fade-in">
            <img
              src={logo}
              alt="Salone Vincente"
              className="w-12 h-12 md:w-16 md:h-16 object-contain animate-float flex-shrink-0"
            />
            <h1 className="flex-1 text-center text-lg md:text-2xl font-bold bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">
              2 ORE DI CONSULENZA GRATUITA
            </h1>
          </div>

          <div className="relative card p-2 md:p-3 shadow-elegant animate-slide-up">
            <YouTubePlayer videoId="LX52gNu1buQ" />
          </div>

          <div className="text-center mt-2 md:mt-3 animate-fade-in">
            <Button
              onClick={handleConsultationRequest}
              size="lg"
              className="shadow-glow text-xs sm:text-sm md:text-base px-4 py-4 sm:px-6 sm:py-6 md:py-8 h-auto"
              disabled={isLoading}
            >
              {isLoading ? "Invio in corso..." : "Voglio essere contattata per la consulenza gratuita"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoStep5;
